'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { getDisplayStyle } from '../../mixins/getDisplayStyle.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { Box } from '../Box/Box.js';
import { getAlignItemsStyle } from './helpers/getAlignItemsStyle.js';
import { getFlexDirectionStyle } from './helpers/getFlexDirectionStyle.js';
import { getFlexStyle } from './helpers/getFlexStyle.js';
import { getFlexWrapStyle } from './helpers/getFlexWrapStyle.js';
import { getJustifyContentStyle } from './helpers/getJustifyContentStyle.js';

const StyledBox = styled(Box).withConfig({
  componentId: "sc-5vww07-0"
})(["", ";", ";", ";", ";", ";", ";", ";"], ({
  display
}) => display && getDisplayStyle(display), ({
  flexDirection
}) => flexDirection && getFlexDirectionStyle(flexDirection), ({
  flexWrap
}) => flexWrap && getFlexWrapStyle(flexWrap), ({
  justifyContent
}) => justifyContent && getJustifyContentStyle(justifyContent), ({
  alignItems
}) => alignItems && getAlignItemsStyle(alignItems), ({
  flex
}) => flex && getFlexStyle(flex), ({
  gap
}) => gap && spaceProp(gap, 'gap'));
const Flex = /*#__PURE__*/withTitan((_a, ref) => {
  var {
      flexDirection,
      flexWrap,
      justifyContent,
      alignItems,
      display = 'flex',
      flex,
      gap,
      children,
      py = 0,
      px = 0,
      testId
    } = _a,
    rest = __rest(_a, ["flexDirection", "flexWrap", "justifyContent", "alignItems", "display", "flex", "gap", "children", "py", "px", "testId"]);
  return jsx(StyledBox, Object.assign({
    ref: ref,
    alignItems: alignItems,
    "data-test-id": testId,
    display: display,
    flex: flex,
    flexDirection: flexDirection,
    flexWrap: flexWrap,
    gap: gap,
    justifyContent: justifyContent,
    px: px,
    py: py
  }, rest, {
    children: children
  }));
}, {
  name: 'Flex'
});

export { Flex };
//# sourceMappingURL=Flex.js.map
